import OfficerService from "../../service/OfficerService";
import swal from 'sweetalert'
import router from "../../router";

export const namespaced = true;

export const state = {
    officers:[],
    officersAdmin:[],
    isOfficersUpt: false,
    isOfficersAdminUpt: false,
    officerLoading: true,
    createLoading: false,
    screen: 'bvn',
    response: {}

}

export const getters = {};

export const mutations = {
    updateOfficers: (state, payload) =>{
        // console.log('Entered Mutation officer', payload);
        state.officers = payload
    },

    updateOfficersAdmin: (state, payload) =>{
        // console.log('Entered Mutation officer', payload);
        state.officersAdmin = payload
    },

    updateResponse: (state, payload) =>{
        // console.log('Entered Mutation officer', payload);
        state.response = payload
    },

    updateIsOfficersUpt: (state, payload) =>{
        // console.log('Entered Mutation officer', payload);
        state.isOfficersUpt = payload;
    },
    updateIsOfficersAdminUpt: (state, payload) =>{
        // console.log('Entered Mutation officer', payload);
        state.isOfficersAdminUpt = payload;
    },
    updateOfficerLoading: (state, payload) =>{
        // console.log('Entered Mutation officer', payload);
        state.officerLoading = payload;
    },
    updateCreateLoading: (state, payload) =>{
        // console.log('Entered Mutation officer', payload);
        state.createLoading = payload;
    },
    updateScreen: (state, payload) =>{
        // console.log('Entered Mutation officer', payload);
        state.screen = payload;
    },
    reset: (state, payload) =>{
        state.officers = [];
        state.officersAdmin = [];
        state.isOfficersUpt =  false;
        state.isOfficersAdminUpt =  false;
        state.officerLoading =  false;
        state.screen =  'reg';
        state.response =  {};
        console.log(payload)
    },
};

export const actions = {
    updateOfficers: ({ commit }, payload)=>{
        // console.log("updateOfficers>>>>>>")
            if(state.officers.length < 1)
                commit("updateOfficerLoading", true)
            return OfficerService.callGetOfficerApi(payload)
            .then(response => {
                commit("updateOfficerLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateOfficerLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    if (responseData.data == null) responseData.data = []
                    commit("updateOfficers", responseData.data)
                }

            })
            .catch(error => {
                commit("updateOfficerLoading", false)
                alert(error)
                // throw error;
            });
    },

    uploadOfficerImage: ({ commit }, payload)=>{
        // console.log("updateOfficers>>>>>>")
        //     commit("updateOfficerLoading", true)
        let dialogs = payload.dialogs;
        delete payload.dialogs;
            return OfficerService.callUploadOfficerImageApi(payload)
            .then(response => {
                commit("updateOfficerLoading", false)
                if (response.data.responseCode !== "00") {
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(response.data.responseMessage, options)
                        .then(res => {
                            console.log(res) // {ok: true|false|undefined}
                        });
                }

            })
            .catch(error => {
                commit("updateOfficerLoading", false)
                alert(error)
                // throw error;
            });
    },

    createOfficers: ({ commit }, payload)=>{
        // console.log("updateOfficers>>>>>>")
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateOfficerLoading", true)
        commit("updateResponse", {})
            return OfficerService.callCreateOfficerApi(payload)
            .then(response => {
                commit("updateOfficerLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateOfficerLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    commit("updateResponse", responseData)
                }else{
                    commit("updateOfficerLoading", false)
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert(response.data.responseMessage, options)
                        .then(res => {
                            console.log(res) // {ok: true|false|undefined}
                            // this.$router.go(-1)
                        });
                }

            })
            .catch(error => {
                commit("updateOfficerLoading", false)
                alert(error)
                // throw error;
            });
    },

    updateOfficersAdmin: ({ commit }, payload)=>{
        // console.log("updateOfficersAdmin>>>>>>")
        commit("updateOfficerLoading", true)
            return OfficerService.callGetOfficerAdminApi(payload)
            .then(response => {
                commit("updateOfficerLoading", false)
                if (response.data.responseCode === "00") {
                    commit("updateOfficerLoading", false)
                    // commit("updateIsUserInfoUpt", true)
                    let responseData = response.data;
                    commit("updateOfficersAdmin", responseData.data)
                }else{
                    swal({
                        title: `Error!`,
                        text: response.data.responseMessage,
                        buttonsStyling: false,
                        confirmButtonClass: 'btn btn-success btn-fill',
                        type: 'error'
                    });
                }

            })
            .catch(error => {
                commit("updateOfficerLoading", false)
                alert(error)
                // throw error;
            });
    },

    verifyOfficer: ({ commit }, payload)=>{
        commit("updateOfficerLoading", true)
            return OfficerService.callUpgradeAccountApi(payload)
            .then(response => {
                commit("updateOfficerLoading", false)
                let responseData = response.data;
                if (response.data.responseCode === "00") {
                    commit("updateOfficerLoading", false)
                    commit("updateIsAccountsUpt", true)
                    // console.log("callupdateAccountsApi responseData ==>>", responseData);
                    swal({
                        title: `Success!`,
                        text: `Account upgrade successfully!`,
                        buttonsStyling: false,
                        confirmButtonClass: 'btn btn-success btn-fill',
                        type: 'success'
                    })
                }else{
                    swal({
                        title: `Error!`,
                        text: responseData.responseMessage,
                        buttonsStyling: false,
                        confirmButtonClass: 'btn btn-success btn-fill',
                        type: 'error'
                    })
                }
            })
            .catch(error => {
                commit("updateOfficerLoading", false)
                alert(error)
            });
    },

    completeCreateOfficer1: ({ commit }, payload)=>{
        commit("updateCreateLoading", true)
        commit("updateResponse", {})
        let dialogs = payload.dialogs;
        delete payload.dialogs;
            return OfficerService.callCompleteCreateOfficer1Api(payload)
            .then(response => {
                commit("updateCreateLoading", false)
                let responseData = response.data;
                commit("updateResponse", responseData)
                if (responseData.responseCode === '00') {
                    const options = {title: 'Info!', size: 'sm'};
                    dialogs.alert('You already have an account with rubies, please enter your password to proceed', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                            commit("updateScreen", 'password')
                        });
                }else if (responseData.responseCode === '01') {
                    const options = {title: 'Info!', size: 'sm'};
                    dialogs.alert('You seems not to an account, please supply the otp sent to your phone and set your password to proceed', options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                            commit("updateScreen", 'setPassword')
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(responseData.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                            //commit("updateScreen", 'password')
                        });
                }
            })
            .catch(error => {
                commit("updateOfficerLoading", false)
                alert(error)
            });
    },

    completeCreateOfficer2: ({ commit }, payload)=>{
            commit("updateCreateLoading", true)
            commit("updateResponse", {})
            let dialogs = payload.dialogs;
            delete payload.dialogs;
                return OfficerService.callCompleteCreateOfficer2Api(payload)
                .then(response => {
                    commit("updateCreateLoading", false)
                    let responseData = response.data;
                    commit("updateResponse", responseData)
                    if (responseData.responseCode === '00') {
                        //commit("updateScreen", 'password')
                        localStorage.accID = responseData.officerAccID;
                        localStorage.orgID = responseData.officerAccID;
                        const options = {title: 'Success!', size: 'sm'};
                        dialogs.alert('Acknowledgment completed, proceed to login so you can upload your passport and signature', options)
                            // eslint-disable-next-line no-unused-vars
                            .then(res => {
                                //console.log(res) // {ok: true|false|undefined}
                                router.push('/');
                            });
                    }else{
                        const options = {title: 'Error!', size: 'sm'}
                        dialogs.alert(response.data.responseMessage, options)
                            // eslint-disable-next-line no-unused-vars
                            .then(res => {
                                //console.log(res) // {ok: true|false|undefined}
                                // this.$router.go(-1)
                            })
                    }
                })
                .catch(error => {
                    commit("updateOfficerLoading", false)
                    alert(error)
                });
        },

    completeCreateOfficer3: ({ commit }, payload)=>{
            commit("updateCreateLoading", true);
            commit("updateResponse", {});
            let dialogs = payload.dialogs;
            delete payload.dialogs;
                return OfficerService.callCompleteCreateOfficer3Api(payload)
                .then(response => {
                    commit("updateCreateLoading", false);
                    let responseData = response.data;
                    commit("updateResponse", responseData);
                    if (responseData.responseCode === '00' || responseData.responseCode === '01') {
                        const options = {title: 'Success!', size: 'sm'};
                        dialogs.alert('OTP has been sent to your phone, please supply to proceed.', options)
                            // eslint-disable-next-line no-unused-vars
                            .then(res => {
                                //console.log(res); // {ok: true|false|undefined}
                                commit("updateScreen", 'otp')
                            });

                    } else{
                        const options = {title: 'Error!', size: 'sm'};
                        dialogs.alert(response.data.responseMessage, options)
                            // eslint-disable-next-line no-unused-vars
                            .then(res => {
                                //console.log(res) // {ok: true|false|undefined}
                                // this.$router.go(-1)
                            });
                    }
                })
                .catch(error => {
                    commit("updateOfficerLoading", false)
                    alert(error)
                });
        },

    completeCreateOfficer4: ({ commit }, payload)=>{
            commit("updateCreateLoading", true)
            commit("updateResponse", {})
            let dialogs = payload.dialogs;
            delete payload.dialogs;
                return OfficerService.callCompleteCreateOfficer4Api(payload)
                .then(response => {
                    commit("updateCreateLoading", false)
                    let responseData = response.data;
                    commit("updateResponse", responseData)
                    if (responseData.responseCode === '00') {
                        localStorage.accID = responseData.officerAccID;
                        localStorage.orgID = responseData.officerAccID;
                        const options = {title: 'Success!', size: 'sm'};
                        dialogs.alert('Acknowledgment complete proceed to login, so you can upload your passport and signature', options)
                            // eslint-disable-next-line no-unused-vars
                            .then(res => {
                                //console.log(res) // {ok: true|false|undefined}
                                router.push('/');
                            });
                    } else {
                        const options = {title: 'Error!', size: 'sm'};
                        dialogs.alert(response.data.responseMessage, options)
                            // eslint-disable-next-line no-unused-vars
                            .then(res => {
                                //console.log(res) // {ok: true|false|undefined}
                                // this.$router.go(-1)
                            });
                    }
                })
                .catch(error => {
                    commit("updateOfficerLoading", false)
                    alert(error)
                });
        },

    verifyOfficersAdmin: ({ commit }, payload)=>{
        let dialogs = payload.dialogs;
        delete payload.dialogs;
        commit("updateOfficerLoading", true)
        commit("updateResponse", {})
            return OfficerService.callVerifyOfficersAdminApi(payload)
            .then(response => {
                commit("updateOfficerLoading", false)
                let responseData = response.data;
                if (response.data.responseCode === "00") {
                    commit("updateOfficerLoading", false)
                    commit("updateResponse", responseData)
                    // commit("updatScreen", 'otp')
                    const options = {title: 'Success!', size: 'sm'};
                    dialogs.alert(response.data.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                            // this.$router.go(-1)
                        });
                }else{
                    const options = {title: 'Error!', size: 'sm'};
                    dialogs.alert(response.data.responseMessage, options)
                        // eslint-disable-next-line no-unused-vars
                        .then(res => {
                            //console.log(res) // {ok: true|false|undefined}
                            // this.$router.go(-1)
                        });
                }
            })
            .catch(error => {
                commit("updateOfficerLoading", false)
                alert(error)
            });
    },

    updateIsOfficersUpt: ({ commit }, payload)=>{
        commit('updateIsOfficersUpt', payload)
    },
    updateIsOfficersAdminUpt: ({ commit }, payload)=>{
        commit('updateIsOfficersUpt', payload)
    },
    reset: ({ commit }, payload)=>{
        commit("reset",payload)
    }

}
